module.exports = __webpack_public_path__ + "static/media/logo.be09df69.png";